import { goto } from "$app/navigation";
import { page } from '$app/state';

export const updateSearchParams = async (updates = {}, options = {}) => {
	const params = new URLSearchParams(page.url.search);
	Object.entries(updates).forEach(([key, value]) => {
		if (value === undefined) return;
		if (value === null || value === "") {
			params.delete(key);
		} else {
			params.set(key, value);
		}
	});
	const query = params.toString();
	const destination = `${page.url.pathname}${query ? `?${query}` : ""}`;
	await goto(destination, {
		replaceState: options.replaceState ?? false,
		noScroll: options.noScroll ?? true,
	});
};

export const openDoc = (docId) =>
	updateSearchParams({
		docId,
	});

export const clearRecordSelection = () => {
	updateSearchParams({ docId: null });
};

export const action = (docId) => openDoc(docId);
